import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { Stepper as MuiStepper, StepConnector as MuiStepConnector, withStyles } from '@material-ui/core';
import styled from 'styled-components';
export function Stepper(props) {
  // If we want to add support for horizontal steppers, we can remove these two
  // assertions.  It will require some styling changes to look correct.
  //
  // We can also decide at that point if we want the default to be
  // horizontal or vertical, since all existing steppers will have
  // labelPosition="below" so it won't be a breaking change to decide on a
  // default
  if (!props.labelPosition) {
    throw new Error('labelPosition is a required prop for <Stepper />');
  }
  if (props.labelPosition !== 'below') {
    throw new Error("The only currently supported value for props.labelPosition is 'below' ");
  }
  return /*#__PURE__*/React.createElement(StyledStepper, {
    activeStep: props.activeStep,
    alternativeLabel: props.labelPosition === 'below',
    connector: /*#__PURE__*/React.createElement(StepConnector, null),
    p: props.p
  }, props.children);
}

// This is why I don't like using theme overrides.  The Stepper uses paper
// internally - but the theme overrides the paper background to grey.  So we
// have to manually change it back to transparent here.
var StyledStepper = styled(MuiStepper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    background-color: transparent;\n    ", "\n  }\n"])), function (props) {
  return props.p === 0 ? 'padding: 0;' : '';
});
var StepConnector = withStyles(function () {
  return {
    horizontal: {
      left: 'calc(-50% + 12px)',
      right: 'calc(50% + 12px)'
    },
    active: {
      '& $line': {
        // This color is nowhere in the ui-components theme or color constants, so
        // hard-coding for now. (It is in crystal-ui, but I don't want to
        // introduce a dependency on crystal-ui from ui-components)  I think the
        // design team updated the colors but we didn't update ui-components. See:
        // https://applyboard.atlassian.net/browse/UIE-182
        borderColor: '#087C69',
        borderTopWidth: 4,
        position: 'relative',
        top: -3
      }
    },
    completed: {
      '& $line': {
        // This color is nowhere in the ui-components theme or color constants, so
        // hard-coding for now. (It is in crystal-ui, but I don't want to
        // introduce a dependency on crystal-ui from ui-components)  I think the
        // design team updated the colors but we didn't update ui-components. See:
        // https://applyboard.atlassian.net/browse/UIE-182
        borderColor: '#087C69',
        borderTopWidth: 4,
        position: 'relative',
        top: -3
      }
    },
    line: {
      // This color is nowhere in the ui-components theme or color constants, so
      // hard-coding for now. (It is in crystal-ui, but I don't want to
      // introduce a dependency on crystal-ui from ui-components)  I think the
      // design team updated the colors but we didn't update ui-components. See:
      // https://applyboard.atlassian.net/browse/UIE-182
      borderColor: '#D7DAE8',
      borderTopWidth: 2
    }
  };
})(MuiStepConnector);